<template>
  <div>
    <WizardBox title="New Price List Template">
      <template v-slot:tools>
        
      </template>
      <template v-slot:content>
        <FormGroup ref="newPriceListTemplateForm" :form="plTemplateForm">
          <FormWizard ref="plTemplateWizard" :form="plTemplateForm" :submitting="submitting" v-bind:tabList="tabList" @finished="handleSubmit()">
            <template v-slot:content>
              
              <FormWizardStep index="1" v-bind:active="true">
                
                <FormRow label="Template Name">
                  <FormInputText placeholder="Name" v-model="priceListData.name" field="name" />
                </FormRow>
                <FormRow label="Description">
                  <FormInputText placeholder="Description" v-model="priceListData.description" field="description" />
                </FormRow>
              </FormWizardStep>
              
              <FormWizardStep index="2">
                <PriceListTemplateEditor
                  ref="priceListTemplateEditor"
                  :editing="true"
                  :isNewTemplate="true"
                  @priceGroupOverrideSettingsUpdated="priceListData.priceGroupOverrideSettings = $event"
                />
              </FormWizardStep>
            </template>
          </FormWizard>
        </FormGroup>
      </template>
    </WizardBox>
  </div>
</template>


<script>
import form from '@/mixins/form'

import PriceListTemplateEditor from '@/modules/pricing/components/priceListTemplateEditor.vue'
import WizardBox from '@/components/wizardBox'

export default {
  name: 'PriceListTemplateNew',
  mixins: [form],
  components: {
    PriceListTemplateEditor,
    WizardBox
  },
  data: () => {
    return {
      plTemplateForm: {},
      submitting: false,
      tabList: [
        { index: 1, title: 'Template Details' },
        { index: 2, title: 'Price List' }
      ],

      priceListData: {
        name: '',
        description: '',
        priceTemplateData: [],
        priceGroupOverrideSettings: []
      }
    }
  },
  methods: {
    handleSubmit() {
      this.submitting = true

      // Build the data
      this.priceListData.priceTemplateData = this.$refs.priceListTemplateEditor.buildServerPriceListUpdateListData()

      this.$apiService.pricingService.createPriceListTemplate(this.priceListData)
        .then((response) => {
          this.successToast('Price List Template Created')
          this.$router.push({ name: 'PriceListTemplate', params: { id: response.data.id } })
        })
        .catch((error) => {
          this.$data.plTemplateForm = this.processFormResponse(error)
          this.$refs.plTemplateWizard.displayErrors()
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>